import React from 'react';
import { STATUS_ACTIVE, STATUS_INACTIVE } from 'Constants';
import { FormattedMessage } from 'react-intl';

/**
 * @param {int} status
 */
export function activeStatusToString(status) {
    const statuses = {};
    statuses[STATUS_ACTIVE] = <FormattedMessage id={'types.status.active'}/>;
    statuses[STATUS_INACTIVE] = <FormattedMessage id={'types.status.inactive'}/>;

    return statuses[status];
}



// WEBPACK FOOTER //
// ./src/utils/activeStatusToString.js